/**
 * Section keys and question strings for the BVA "Human Tension" wheel and the
 * PDF one-pager. Single source of truth so the on-screen wheel
 * (HumanTension.tsx) and the PDF template (pages/BrandDetails/pdf/) can never
 * drift apart on a question label -- both resolve answers through
 * `getAnswer(sections, section, questionText)` using these exact strings.
 */

export const BVA_SECTIONS = {
  humanTension: 'HUMAN_TENSION',
  productEdge: 'PRODUCT_EDGE',
  brandEdge: 'BRAND_EDGE',
  meaningfulBrandRole: 'MEANINGFUL_BRAND_ROLE',
} as const

export const HUMAN_TENSION_QUESTIONS = [
  'Who are you for?',
  'What are their belief/values?',
  'What need are they trying to fulfill?',
] as const

export const PRODUCT_EDGE_QUESTIONS = [
  'Sensorial Cues',
  'Reason to Believe',
  'Product Superiority Insights',
  'Functional Benefit',
] as const

export const BRAND_EDGE_QUESTIONS = [
  'Personality',
  'Memory Structure',
  'Brand Philosophy',
  'Emotional Benefit',
] as const

export const MEANINGFUL_BRAND_ROLE_QUESTION = 'What is the Meaningful Brand Role?'

export const HUMAN_TENSION_TAGLINE_QUESTION = 'What is the Human Tension?'
export const PRODUCT_EDGE_TAGLINE_QUESTION = 'Describe the Product Edge'
export const BRAND_EDGE_TAGLINE_QUESTION = 'Describe the Brand Edge'
